/**
 * Kontoverbindungen
 * API für Kontoverbindungen
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KontoverbindungStatusEnumDto, KontoverbindungStatusEnumDtoValidator } from './kontoverbindungStatusEnumDto';


export interface KontoverbindungSummaryDto { 
    /**
     * 2-stellig
     */
    subnummer: string;
    subnummerText: string;
    iban: string;
    kontoinhaber: string;
    zahlungsverbindungId: string;
    status: KontoverbindungStatusEnumDto;
}

import {Validators} from "@angular/forms";
import {SuxValidators} from "@suva-ch/suvauxlib/modules/form";
import {OpenApiValidators} from "../validators";
export const KontoverbindungSummaryDtoValidator = {
    subnummer: {
        restrictions: { required: true},
        validator: (convert = false) => Validators.compose([Validators.required])
    },
    subnummerText: {
        restrictions: { required: true},
        validator: (convert = false) => Validators.compose([Validators.required])
    },
    iban: {
        restrictions: { required: true},
        validator: (convert = false) => Validators.compose([Validators.required])
    },
    kontoinhaber: {
        restrictions: { required: true},
        validator: (convert = false) => Validators.compose([Validators.required])
    },
    zahlungsverbindungId: {
        restrictions: { required: true},
        validator: (convert = false) => Validators.compose([Validators.required])
    },
    status: {
        restrictions: {
            enumVals: Object.values(KontoverbindungStatusEnumDto), required: true
        },
        validator: () => Validators.compose([KontoverbindungStatusEnumDtoValidator, Validators.required])
    },
}
